// extracted by mini-css-extract-plugin
module.exports = {"baseFilter":"BaseFilter_baseFilter_1haaz"};